<template>
  <div>
    <div v-show="isLoading" class="loader">
      <b-spinner class="align-middle mb-3" />
      <strong>Loading...</strong>
    </div>

    <div v-show="!isLoading">
      <div v-if="importResult?.failed_count === 0" class="card p-4">
        <div class="success text-center">
          <img width="385" height="287" alt="upload success" :src="uploadSuccessImg" />
          <h5 class="mt-2 mb-3">
            {{ $t('global.importResult.successUpload') }}
          </h5>
          <p>{{ $t('master.product.upload.successUpload.subtitle') }}</p>
        </div>
      </div>

      <template v-else>
        <McAlert
          withIcon
          variant="error"
          class="alert-error mb-4"
          :text="$t('global.importResult.invalidTemplate')"
        />
        <b-tabs v-model="activeTab" lazy>
          <b-tab title="Informasi Produk" class="card p-4">
            <Table :fields="productInfoFields" :listGetter="fetchData" />
          </b-tab>
          <b-tab title="Unit Konversi" class="card p-4">
            <Table :fields="conversionFields" :listGetter="fetchData" />
          </b-tab>
        </b-tabs>
      </template>
    </div>
  </div>
</template>

<script>
import uploadSuccessImg from '@/assets/images/upload-success.png'

import McAlert from '@/components/McAlert'
import Table from '../components/Table'

import { productInfoFields, conversionFields } from '../lib/uploadResultFields'

import { getImportResult } from '@/services/rest-api/lib/product/import'

const resourceTypes = ['product', 'product_uom_conversion']

export default {
  components: {
    Table,
    McAlert,
  },
  inject: ['importResult', 'resetImportResult', 'setImportResult'],
  data() {
    return {
      activeTab: 0,
      productInfoFields,
      conversionFields,
      isLoading: false,
      uploadSuccessImg,
    }
  },
  beforeDestroy() {
    this.resetImportResult()
  },
  methods: {
    async fetchData(opts) {
      // For showing initial loader
      if (!this.importResult) {
        this.isLoading = true
      }

      const res = await getImportResult(this.$route.params.id, {
        ...opts,
        resource: resourceTypes[this.activeTab],
        format: 'json',
      })

      if (!res || res.errors) return

      // Only set metadata on initial load
      if (!this.importResult) {
        const { failed_count, success_count, processed_count } = res.metadata
        this.setImportResult({
          failed_count,
          success_count,
          total_count: processed_count,
        })
      }

      this.isLoading = false

      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.alert-error {
  width: fit-content;
}

.loader {
  min-height: min(50vh, 500px);
  display: grid;
  place-items: center;
  place-content: center;
  background-color: white;
}
</style>
